import {
  type BloodPressureParams,
  calculateBloodPressure,
} from './blood-pressure';
import { calculateGlucose } from './glucose';
import { compose } from './interpreter';
import {
  calculateEarlyWarningScores,
  type EarlyWarningScoreParams,
} from './news';

export { getMetadata, isValidReading } from './metadata';

type CalculateDerivedProps = EarlyWarningScoreParams & BloodPressureParams;

export const calculateDerivedMeasures = compose<CalculateDerivedProps>([
  calculateBloodPressure,
  calculateEarlyWarningScores,
  calculateGlucose,
]);

export { getAggregatedRanges } from './aggregate';
